<template>
  <div>
    <!-- 面包屑导航 -->
  <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>工作台</el-breadcrumb-item>
      <el-breadcrumb-item>我的工作台</el-breadcrumb-item>
      <el-breadcrumb-item>部门预决算</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-date-picker v-model="keywords.budgettime" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.budgettype" @keyup.enter.native="clicksearch" placeholder="请输入费用分类" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.budgetdetail" @keyup.enter.native="clicksearch" placeholder="请输入费用描述" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Jigouname" label="部门名称" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Budgettime" label="月份" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Budgettype" label="费用分类" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Budgetdetail" label="费用描述" header-align="center" align="center" min-width="16%"></el-table-column>
          <el-table-column prop="Budgetdanwei" label="单位" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetnum" label="数量" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetprice" label="单价" header-align="center" align="center" min-width="4%"></el-table-column>
          <el-table-column prop="Budgetamount" label="预算金额" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Budgetrealspending" label="实际支出" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Budgetsuppliername" label="供应商名称" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Budgetbeizhu" label="备注" header-align="center" align="center" min-width="9%"></el-table-column>
          <el-table-column prop="Budgetuseridcreatename" label="经办人" header-align="center" align="center" min-width="5%"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" header-align="center" align="center" min-width="10%"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" min-width="8%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="8"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加">
        <el-form :model="addData" ref="addDataRef" label-width="180px">
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">月份(必填)</span>
            </label>
            <el-date-picker v-model="addData.budgettime" type="month" placeholder="选择月" class="select" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">费用分类(必填)</span>
            </label>
            <el-input v-model="addData.budgettype" placeholder="请输入费用分类"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">费用描述(必填)</span>
            </label>
            <el-input type="textarea" rows="3" v-model="addData.budgetdetail" placeholder="请输入费用描述"></el-input>
          </el-form-item>
          <el-form-item label="单位(选填)" class="addAdminForm">
            <el-input v-model="addData.budgetdanwei" placeholder="请输入单位"></el-input>
          </el-form-item>
          <el-form-item label="数量(选填)" class="addAdminForm">
            <el-input v-model="addData.budgetnum" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item label="单价(选填)" class="addAdminForm">
            <el-input v-model="addData.budgetprice" placeholder="请输入单价"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">预算金额(必填)</span>
            </label>
            <el-input v-model="addData.budgetamount" placeholder="请输入预算金额"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">实际支出(必填)</span>
            </label>
            <el-input v-model="addData.budgetrealspending" placeholder="请输入实际支出"></el-input>
          </el-form-item>
          <el-form-item label="供应商名称(选填)" class="addAdminForm">
            <el-input v-model="addData.budgetsuppliername" placeholder="请输入供应商名称"></el-input>
          </el-form-item>
          <el-form-item label="备注(选填)" class="addAdminForm">
            <el-input v-model="addData.budgetbeizhu" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <WorkdepartmentbudgetChange ref="SubVuesecond" v-on:triggerFunc="clickreturn"></WorkdepartmentbudgetChange>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import WorkdepartmentbudgetChange from '@/componentsSubVue/WorkdepartmentbudgetChange.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    WorkdepartmentbudgetChange
  },
  name: 'MyWorkdepartmentbudget',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      // 筛选条件
      keywords: {
        budgettime: '',
        budgettype: '',
        budgetdetail: ''
      },
      // 添加
      addData: {
        budgettime: '',
        budgettype: '',
        budgetdetail: '',
        budgetdanwei: '',
        budgetnum: '',
        budgetprice: '',
        budgetamount: '0.00',
        budgetrealspending: '0.00',
        budgetsuppliername: '',
        budgetbeizhu: ''
      }
    }
  },
  mounted () {
    this.apiGetWorkdepartmentbudgetNum()
    this.apiGetWorkdepartmentbudgetList()
  },
  methods: {
    clickreturn () {
      this.activeName = 'first'
      this.apiGetWorkdepartmentbudgetNum()
      this.apiGetWorkdepartmentbudgetList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWorkdepartmentbudgetList()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWorkdepartmentbudgetNum()
      this.apiGetWorkdepartmentbudgetList()
    },
    clickadd () {
      this.apiAddWorkdepartmentbudget()
    },
    clickdelete (row) {
      this.$confirm('是否删除此预决算?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDeleteWorkdepartmentbudget(row)
      })
    },
    clickedit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row)
    },
    apiGetWorkdepartmentbudgetList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        budgettime: that.keywords.budgettime,
        budgettype: that.keywords.budgettype,
        budgetdetail: that.keywords.budgetdetail
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkdepartmentbudgetList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkdepartmentbudgetNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        budgettime: that.keywords.budgettime,
        budgettype: that.keywords.budgettype,
        budgetdetail: that.keywords.budgetdetail
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkdepartmentbudgetNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddWorkdepartmentbudget: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        budgettime: that.addData.budgettime,
        budgettype: that.addData.budgettype,
        budgetdetail: that.addData.budgetdetail,
        budgetdanwei: that.addData.budgetdanwei,
        budgetnum: that.addData.budgetnum,
        budgetprice: that.addData.budgetprice,
        budgetamount: that.addData.budgetamount,
        budgetrealspending: that.addData.budgetrealspending,
        budgetsuppliername: that.addData.budgetsuppliername,
        budgetbeizhu: that.addData.budgetbeizhu
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddWorkdepartmentbudget, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.budgettime = ''
            that.addData.budgettype = ''
            that.addData.budgetdetail = ''
            that.addData.budgetdanwei = ''
            that.addData.budgetnum = ''
            that.addData.budgetprice = ''
            that.addData.budgetamount = '0.00'
            that.addData.budgetrealspending = '0.00'
            that.addData.budgetsuppliername = ''
            that.addData.budgetbeizhu = ''

            that.apiGetWorkdepartmentbudgetNum()
            that.apiGetWorkdepartmentbudgetList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeleteWorkdepartmentbudget: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        workdepartmentbudgetid: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeleteWorkdepartmentbudget, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiGetWorkdepartmentbudgetNum()
            that.apiGetWorkdepartmentbudgetList()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
